/**
 * @fileoverview POST handler for the "/apps/engagement_reports/update_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsEngagementReportsUpdateTagsCacheKeys } from "./constants";
import type { PutAppsEngagementReportsUpdateTagsProps, AppsEngagementReportsUpdateTagsResult } from "./types";

export const putAppsEngagementReportsUpdateTags = reactQueryMutationAdapter(
  appsEngagementReportsUpdateTagsCacheKeys,
  (props: PutAppsEngagementReportsUpdateTagsProps): Promise<AppsEngagementReportsUpdateTagsResult> => {
    return fetch("/apps/engagement_reports/update_tags", "PUT", props);
  }
);
